export function getViewAllUrl(slug) {
  return `/3d-models?collection_slug=${slug.toLowerCase()}`
}
